import { bankingService } from '@afterpaytouch/portal-api/consumer/bankingSessions'

export const { useUpdateBankingSessionsMutation, useGetLatestBankingSessionQuery, useGetBankingSessionLatestQuery } = bankingService
